import { ErrorOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'

export function Error404() {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='ошибка 404'
          subtitle='Страница не найдена'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/'
          linkText='На главную'
        />
      </div>
    </MainLayout>
  )
}
